import React from 'react';
import { Enemy as StyledEnemy } from '../styles/StyledComponents';
import { Enemy as EnemyType } from '../hooks/useGame';

interface EnemyProps {
  enemy: EnemyType;
}

const Enemy: React.FC<EnemyProps> = ({ enemy }) => {
  return (
    <StyledEnemy 
      position={enemy.position} 
    />
  );
};

export default Enemy;
